<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>home</v-flex>
    <!-- <v-flex xs12>
      <v-btn :to="{name: 'listmjspo'}">
        梦加2.0
      </v-btn>

      <v-btn :to="{name: 'listshcspo'}">
        shc(鱼跃...)
      </v-btn>

      <v-btn :to="{path: 'listmhn'}">
        MegaHealthNew
      </v-btn>
    </v-flex> -->
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue